import Component from '@glimmer/component';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { isBlank } from '@ember/utils';
import { task, lastValue } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { hash } from 'rsvp';

export default class VisitorsTrialEndModalBillingAdminCouponExperiment extends Component {
  @service statsig;
  @service store;
  @service state;
  @service flashMessages;
  @service router;

  @lastValue('loadPlans') plans;

  constructor() {
    super(...arguments);
    this.loadPlans.perform();
  }

  loadPlans = task({ drop: true }, async () => {
    return hash({
      standardPlan: this.store.findRecord('plan', 'standard-1'),
      premiumPlan: this.store.findRecord('plan', 'premium'),
    });
  });

  get coupons() {
    const items = [];
    const experiment = this.statsig.getExperiment('visitor_trial_end_coupon_experiment');

    if (!isBlank(experiment.value['standard_coupon_set']) && this.plans?.standardPlan) {
      items.push({
        couponSetId: experiment.value['standard_coupon_set'],
        percentage: experiment.value['standard_coupon_percentage'],
        plan: this.plans.standardPlan,
      });
    }

    if (!isBlank(experiment.value['premium_coupon_set']) && this.plans?.premiumPlan) {
      items.push({
        couponSetId: experiment.value['premium_coupon_set'],
        percentage: experiment.value['premium_coupon_percentage'],
        plan: this.plans.premiumPlan,
      });
    }

    return items;
  }

  generateCouponCodeTask = task({ drop: true }, async ({ couponSetId, plan }) => {
    const company = this.state.currentCompany;

    const couponCode = this.store.createRecord('coupon-code', {
      company: company,
      couponSetId: couponSetId,
    });

    try {
      await couponCode.save();

      this.router.transitionTo('billing.subscribe', {
        queryParams: { period: 'yearly', plan: get(plan, 'id'), coupon: couponCode.id },
      });
    } catch (e) {
      const errorText = parseErrorForDisplay(e);
      this.flashMessages.showAndHideFlash('error', errorText);
    }
  });
}
